<template>
  <div
    class="plagiarism_card d_card_slim margin-bottom-25"
    :class="[noPlagCurrentPopup === plagiarism_result['id'] ? 'card_active' : '']"
    :id="'plag-card-' + plagiarism_result['id']"
    :style="{ height: cardHeight + 'px' }"
    @click="onClickResultPlag"
  >
    <a style="text-decoration: none; cursor: pointer">
      <!--:href="'#selectorPlagLineResult-'+plagiarism_result.id+'-'+plagiarism_result.linesList[0].lineId">-->
      <div class="d-flex flex-row">
        <div class="d-flex justify-content-center align-items-center" style="min-width: 60px">
          <div class="index_result">{{ index }}</div>
        </div>
        <div class="margin-right-5" ref="plaCardMid" style="width: 100%">
          <div class="title_source" v-if="plagiarism_result.isIgnoredBySystem">Nội dung không được kiểm tra</div>
          <div class="title_source" v-else-if="plagiarism_result.isIgnored">Người dùng đã đánh dấu loại bỏ</div>
          <div v-else>
            <truncate
              clamp="..."
              :length="45"
              class="title_source"
              :text="currentSimilarSource.title"
              :title="currentSimilarSource.title"
            />
            <!--                                :title="plagiarism_result.titleSource.split('.')[0]"-->
          </div>

          <div v-if="!plagiarism_result.isIgnored && !plagiarism_result.isIgnoredBySystem">
            <div
              class="short_link"
              v-if="currentSourceType === DocumentSourceType.WEB"
              :title="currentSimilarSource.url"
            >
              {{ currentSimilarSource.domain }}
            </div>
            <div class="short_link" v-else-if="currentSourceType === DocumentSourceType.THESIS">Dữ liệu nội bộ</div>
            <div class="short_link" v-else-if="currentSourceType === DocumentSourceType.GROUP">Tài liệu trong nhóm</div>
          </div>
        </div>

        <div v-if="plagiarism_result.isIgnoredBySystem" class="ml-auto margin-right-5">
          <div class="cell_group d-flex flex-column bd-highlight mb-3 justify-content-end align-items-end">
            <div class="p-2 cell_color level_ignored"></div>
            <div class="p-2 cell_color level_ignored"></div>
            <div class="p-2 cell_color level_ignored"></div>
          </div>
        </div>
        <div v-else-if="plagiarism_result.isIgnored" class="ml-auto margin-right-5">
          <div class="cell_group d-flex flex-column bd-highlight mb-3 justify-content-end align-items-end">
            <div class="p-2 cell_color level_ignoredByUser"></div>
            <div class="p-2 cell_color level_ignoredByUser"></div>
            <div class="p-2 cell_color level_ignoredByUser"></div>
          </div>
        </div>
        <div v-else class="ml-auto margin-right-5">
          <div
            v-if="currentFlagLevel === PlagScoresType.HIGH"
            class="cell_group d-flex flex-column bd-highlight mb-3 justify-content-end align-items-end"
          >
            <div class="p-2 cell_color level_high"></div>
            <div class="p-2 cell_color level_high"></div>
            <div class="p-2 cell_color level_high"></div>
          </div>

          <div
            v-else-if="currentFlagLevel === PlagScoresType.MEDIUM"
            class="cell_group d-flex flex-column bd-highlight mb-3 justify-content-end align-items-end"
          >
            <div class="p-2 cell_color level_medium"></div>
            <div class="p-2 cell_color level_medium"></div>
            <div class="p-2 cell_color level_transparent"></div>
          </div>

          <div
            v-else-if="currentFlagLevel === PlagScoresType.LOW"
            class="cell_group d-flex flex-column bd-highlight mb-3 justify-content-end align-items-end"
          >
            <div class="p-2 cell_color level_low"></div>
            <div class="p-2 cell_color level_transparent"></div>
            <div class="p-2 cell_color level_transparent"></div>
          </div>

          <div v-else class="cell_group d-flex flex-column bd-highlight mb-3 justify-content-end align-items-end">
            <div class="p-2 cell_color level_transparent"></div>
            <div class="p-2 cell_color level_transparent"></div>
            <div class="p-2 cell_color level_transparent"></div>
          </div>
        </div>
      </div>
    </a>

<!--    <transition name="slide">-->
<!--      <div-->
<!--        id="sources-list"-->
<!--        class="local-scroller scrollable"-->
<!--        v-if="isDetails"-->
<!--        :style="{ height: sourcesListHeight + 'px' }"-->
<!--      >-->
<!--        <div-->
<!--          class="d-flex flex-row"-->
<!--          v-for="(source_data, index) in sourcesList.slice(0, Math.min(5, sourcesList.length))"-->
<!--          :key="index"-->
<!--          :class="{'group-margin': isGroupResult}"-->
<!--        >-->
<!--          <div class="remove-btn-container" v-if="!isGroupResult">-->
<!--            <SourceItem :source-data="source_data" @handle-command="handleCommand($event)"></SourceItem>-->
<!--          </div>-->
<!--          <div class="details-item">-->
<!--            <p v-html="source_data.title"></p>-->
<!--            <a-->
<!--              v-if="source_data.type === DocumentSourceType.WEB"-->
<!--              :href="source_data.url"-->
<!--              target="_blank"-->
<!--              class="source-link"-->
<!--              >{{ source_data.url }}</a-->
<!--            >-->
<!--            <a-->
<!--              v-else-if="source_data.type === DocumentSourceType.GROUP"-->
<!--              :href="source_data.url"-->
<!--              target="_blank"-->
<!--              class="source-link"-->
<!--            >-->
<!--              Tài liệu trong nhóm-->
<!--            </a>-->
<!--            <a v-else href="#" class="source-link">Dữ liệu nội bộ</a>-->
<!--          </div>-->
<!--        </div>-->
<!--        <el-button-->
<!--          type="text"-->
<!--          style="width: 100%"-->
<!--          @click="isOpenDetailsDialog = true"-->
<!--          class="disable_btn_focus"-->
<!--          v-if="sourcesList.length > 5"-->
<!--        >-->
<!--          Xem thêm...-->
<!--        </el-button>-->
<!--      </div>-->
<!--    </transition>-->
    <!--        converted_plagiarism_result.ignored-->
    <!--        isIgnoredByUser-->
<!--    <div @mouseenter="onLinksButtonHover" @mouseleave="onLinksButtonHover">-->
<!--      <el-button-->
<!--        id="show-links-btn"-->
<!--        class="disable_btn_focus"-->
<!--        v-if="isSimilarSources"-->
<!--        :icon="isDetails ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"-->
<!--        @click.stop="handleShowDetail"-->
<!--      >-->
<!--        <transition name="slide-fade"-->
<!--          ><span v-show="isLinksButtonHover">{{ isDetails ? 'Thu gọn' : 'Hiển thị các nguồn' }}</span></transition-->
<!--        >-->
<!--      </el-button>-->
<!--    </div>-->
    <el-dialog width="30%" :visible.sync="isOpenDetailsDialog">
      <div id="details-header">Tất cả các nguồn</div>
      <div id="details-body" class="local-scroller scrollable">
        <div class="d-flex flex-row" :class="{'group-margin': isGroupResult}" v-for="(source_data, index) in sourcesList" :key="index">
          <div class="remove-btn-container" v-if="!isGroupResult">
            <SourceItem :source-data="source_data" @handle-command="handleCommand($event)"></SourceItem>
          </div>
          <div class="details-item">
            <p v-html="source_data.title"></p>
            <a
              v-if="source_data.type === DocumentSourceType.WEB"
              :href="source_data.url"
              target="_blank"
              class="source-link"
              >{{ source_data.url }}</a
            >
            <a
              v-else-if="source_data.type === DocumentSourceType.GROUP"
              :href="source_data.url"
              target="_blank"
              class="source-link"
              >{{ source_data.title }}</a
            >
            <a v-else href="#" class="source-link">Dữ liệu nội bộ</a>
          </div>
        </div>
      </div>
      <!--            <div id="details-close-container">-->
      <!--                <el-button type="primary" @click="isOpenDetailsDialog = false">Đóng</el-button>-->
      <!--            </div>-->
    </el-dialog>
  </div>
</template>

<script>
import truncate from 'vue-truncate-collapsed'
import SourceItem from './SourceItem'
import _ from 'lodash'
import { DocumentSourceType, IgnoredSourceType, PlagScoreType } from '@/constants/DoITConstant'
import { getLevelPlagiarism } from '@/services/doit_result_service'
import { getDocumentSourceType } from '@/helpers/StringHelper'

export default {
  name: 'PlagiarismCard',
  components: {
    truncate,
    SourceItem,
  },
  props: {
    plagiarism_result: {
      type: Object,
    },
    ignoringSourceList: {
      type: Array,
    },
    index: {
      type: Number,
    },
    isGroupResult: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
  },
  data: () => {
    return {
      isDetails: false,
      isLinksButtonHover: false,
      isOpenDetailsDialog: false,
      sourcesList: [],
      DocumentSourceType,
      PlagScoresType: PlagScoreType,
    }
  },
  methods: {
    handleShowDetail() {
      if (!this.isDetails) {
        let sources = [{ ...this.currentSimilarSource, type: this.currentSourceType }]
        let availableSources = _.pickBy(this.similarSources, (source) => {
          return this.ignoringSourceList.findIndex((elem) => elem.targetId === source.id) === -1
        })
        const similaritiesGroupBySentenceId = _.groupBy(Object.values(this.similarities), (x) => x.sentenceId)
        let sentencesList = new Set()
        for (let part of this.plagiarism_result.parts) {
          if (part.sentenceId) {
            sentencesList.add(part.sentenceId)
          } else {
            let similarity = this.similarities[part.similarityId]
            sentencesList.add(similarity.sentenceId)
          }
        }
        sentencesList.forEach((sentenceId) => {
          let similaritiesBySentenceId = similaritiesGroupBySentenceId[sentenceId]
          similaritiesBySentenceId.forEach((similarity) => {
            let foundSource = availableSources[similarity.similarSourceId]
            if (foundSource) {
              if (sources.findIndex((source) => source.url === foundSource.url) === -1) {
                sources.push({
                  id: foundSource.id,
                  url: foundSource.url,
                  domain: foundSource.domain,
                  title: foundSource.title,
                  type: getDocumentSourceType(foundSource),
                })
              }
            }
          })
        })
        this.sourcesList = sources
        this.isLoadedData = true
      }
      this.isDetails = !this.isDetails
    },
    onLinksButtonHover() {
      this.isLinksButtonHover = !this.isLinksButtonHover
    },
    handleCommand(command) {
      if (command.type === IgnoredSourceType.URL) {
        this.$emit('excludeLink', { domains: [], sourceIds: command.data })
        let index = this.sourcesList.findIndex((source) => source.id === command.data[0])
        this.sourcesList.splice(index, 1)
      } else if (command.type === IgnoredSourceType.DOMAIN) {
        this.$emit('excludeLink', { domains: command.data, sourceIds: [] })
        this.sourcesList = this.sourcesList.filter((source) => source.domain !== command.data[0])
      }
      if (this.sourcesList.length === 0) this.isDetails = false
    },
    onClickResultPlag(e) {
      // if (this.noPlagCurrentPopup !== this.plagiarism_result['no']) {
      // console.log(result_plag)
      let line = this.plagiarism_result.parts[0]
      let pageCurrent = this.plagiarism_result.parts[0].pageId
      let parts = this.plagiarism_result.parts
      if (line.highlights) {
        line = line.highlights[0]
      } else {
        let similarity = this.similarities[line.similarityId]
        line = similarity.highlights[0]
        pageCurrent = similarity.highlights[0].pageId
        parts = [similarity]
      }

      this.$store.dispatch('docRes/plagiarism/updateIsShowPlagPopup', false)
      this.$store.dispatch('docRes/plagiarism/updatePlagNo', this.plagiarism_result['id'])
      this.$store.dispatch('docRes/plagiarism/updateNoPagePlagCurrentPopup', pageCurrent)
      this.$store.dispatch('docRes/plagiarism/updateIsShowPlagPopup', true)
      this.$store.dispatch('docRes/plagiarism/updateResultPlagCurrentPopup', {
        ...this.plagiarism_result,
        pageId: pageCurrent,
        parts,
      })
      this.$store.dispatch('docRes/plagiarism/updateResultLineCurrentPopup', line)
      const currentPageContainer = document.getElementById(`page-${pageCurrent}-container`)
      currentPageContainer.scrollIntoView({
        behavior: 'auto',
        inline: 'center',
      })
      console.log(currentPageContainer.parentElement.scrollTop)
      currentPageContainer.parentElement.scrollTo(0, currentPageContainer.parentElement.scrollTop + line.top)

      document.getElementById(`page-preview-${pageCurrent}`).scrollIntoView({
        behavior: 'auto',
        inline: 'center',
      })
      // }
    },
  },
  computed: {
    isSimilarSources() {
      return !this.plagiarism_result.isIgnored && !this.plagiarism_result.isIgnoredBySystem
    },
    noPlagCurrentPopup() {
      return this.$store.getters['docRes/plagiarism/noPlagCurrentPopup']
    },
    noLinePlagCurrentPopup() {
      return this.$store.getters['docRes/plagiarism/noLinePlagCurrentPopup']
    },
    isShowPlagPopup() {
      return this.$store.getters['docRes/plagiarism/isShowPlagPopup']
    },
    lstResultPlagIgnoredCurrent() {
      return this.$store.getters['docRes/plagiarism/lstResultPlagIgnoredCurrent']
    },
    sourcesListHeight() {
      if (this.sourcesList.length >= 5) {
        return 445
      } else {
        return 80 * this.sourcesList.length + 15
      }
    },
    cardHeight() {
      if (this.isDetails) {
        if (this.sourcesList.length >= 5) {
          return 600
        } else {
          return 80 * this.sourcesList.length + 170
        }
      } else {
        return 154
      }
    },
    similarities() {
      return this.$store.getters['docRes/plagiarism/getAllSimilarities']
    },
    similarSources() {
      return this.$store.getters['docRes/plagiarism/getAllSimilarSources']
    },
    currentSimilarSource() {
      return this.similarSources[this.plagiarism_result.similarSourceId]
    },
    currentSourceType() {
      // const url = this.currentSimilarSource['url']
      return getDocumentSourceType(this.currentSimilarSource)
    },
    currentFlagLevel() {
      const configScore = this.$store.getters['docRes/plagiarism/getConfigDocumentScore']
      return getLevelPlagiarism(this.plagiarism_result.score, configScore)
    },
  },
  watch: {
    index: function (newVal, oldVal) {
      this.isDetails = false
      this.sourcesList = []
    },
  },
}
</script>

<style scoped>
.group-margin {
  margin-left: 20px;
}

.plagiarism_card {
  border-left: 1px solid #e5e5e5;
  overflow: hidden;
  cursor: pointer;
}

.index_result {
  font-size: 18px;
  /*line-height: 70px;*/
  /*margin-left: 20px;*/
  /*margin-top: 15px;*/
  color: #6c757d;
}

.title_source {
  font-size: 14px;
  margin-top: 15px;
  height: calc(100% - 44px);
}

.short_link {
  font-size: 13px;
  color: #6c757d;
  margin-top: 15px;
  margin-bottom: 15px;
}

.cell_color {
  margin-bottom: 5px;
  width: 2px;
  height: 25px;
}

.cell_group {
  margin-top: 10px;
}

.level_high {
  background-color: rgba(255, 0, 0, 0.5);
}

.level_medium {
  background-color: rgba(243, 156, 18, 0.5);
}

.level_low {
  background-color: rgba(254, 241, 96, 0.5);
}

.level_transparent {
  background-color: rgba(0, 0, 0, 0);
}

.level_ignored {
  background-color: rgba(108, 122, 137, 0.5);
}

.level_ignoredByUser {
  background-color: rgba(37, 116, 169, 0.2);
}

.slide-enter,
.slide-leave-to {
  transform: scaleY(0);
}

.slide-fade-enter-active {
  transition: all 0.5s ease;
}

.slide-fade-leave-active {
  transition: all 0.2s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter, .slide-fade-leave-to
    /* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}

#show-links-btn {
  width: 100%;
  border-radius: 0;
  /*background-color: rgba(255,255,255,0.2);*/

  border-width: 1px 0 0 0;
  border-style: solid;
  border-color: #f4f4f4;
  background-color: rgba(193, 193, 193, 0);
}

#show-links-btn:hover {
  background-color: rgba(193, 193, 193, 0);
  color: #3d5396;
  font-weight: 600;
}

/*#show-links-btn:active {*/
/*    box-shadow: none;*/
/*}*/

#sources-list {
  border-top: 1px solid #f4f4f4;
  background-color: #fbfbfb;
}

.details-item {
  margin: 15px 5px 6px 30px;
  border-bottom: 1px solid #ffaa8c;
  line-height: 1;
  font-size: 10px;
  width: 75%;
}

.details-item p,
.details-item a {
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 8px;
}

.source-link {
  color: gray;
  display: block;
}

.remove-btn-container {
  padding: 20px 0 20px 20px;
}

#details-header {
  margin-top: -38px;
  margin-bottom: 20px;
  margin-left: 25px;
  font-size: 22px;
  font-weight: 600;
  width: 60%;
  /*padding-bottom: 10px;*/
  /*border-bottom: 2px solid grey;*/
}

#details-body {
  max-height: 490px;
  width: 90%;
  margin: auto;
}

#details-close-container {
  text-align: right;
  margin-top: 30px;
  /*margin-right: 5px;*/
  width: 93%;
}
</style>
